















































































































































































import { Component, Vue } from 'nuxt-property-decorator';
import axios from 'axios';

@Component({
  head: {
    title: 'YouSpeakオンライン英会話'
  }
})
export default class ContactPage extends Vue {
  drawer: boolean = false;
  token: string = '';

  name: string = '';
  email: string = '';
  message: string = '';

  overlay = false;
  valid = false;
  isSending = false;

  inputRequiredRules: any = [
    v => !!v || '入力してください'
  ];

  async asyncData () {
    const result = await axios.get(
      `${process.env.FORM_MAILER_URL}GetSenderToken?code=z37/DvlQs3mPGa97iammyR1sxoVyfLuQAEIaT5ldXRuNav7lN67AmA==&id=bbb1bb05-b31c-4ab2-a9c8-f3d677cb806e`);

    if (result.status !== 200) {
      this.$router.push('/');
    } else {
      return {
        token: result.data
      }
    }
  }

  goTop () {
    this.$router.push('/');
  }

  goCourse () {
    this.$router.push('/#course')
  }

  goAbout () {
    this.$router.push('/about')
  }

  goContact () {
    this.$router.push('/contact')
  }

  nextStep () {
    this.overlay = true;
  }

  async submit () {
    this.isSending = true;

    this.$nuxt.$loading.start();

    const result = await axios.post(
      `${process.env.FORM_MAILER_URL}SendMail?code=iDz9or7aSmqQ47PNeV283QacPH1PtwrRJvrnSse8dr3gayJY23Sdaw==&id=bbb1bb05-b31c-4ab2-a9c8-f3d677cb806e&token=${this.token}`,
      {
        name: this.name,
        email: this.email,
        message: this.message
      }
    );

    this.$nuxt.$loading.finish();
    this.isSending = false;
    this.overlay = false;

    if (result.status !== 200) {
      alert('送信中にエラーが発生しました。再度送信するか、何度もエラーが出る場合は、お手数ですが電話かメールでお問い合わせください。');
      return;
    }

    this.$router.push('/contact/thankyou');
  }

  backToForm () {
    this.overlay = false;
  }
}
